import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import Row from 'kepler/lib/components/Row';
import { PARTNER_DETAIL_ICONS } from '../lib/constants';
import AppDetailContentDescriptionPoint from './AppDetailContentDescriptionPoint';
import getContent from '../lib/dictionaryFetcher';

const AppDetailContentDescriptionPoints = props => {
  const { partner, isDesktop } = props;

  const titles = getContent(
      'merchanthub',
      `apps.${partner}.descProps.titles`,
      []
    ),
    points = getContent('merchanthub', `apps.${partner}.descProps.points`, []),
    icons = get(PARTNER_DETAIL_ICONS, partner, 'recommended');

  return (
    <div className="marketplace-fulldescription-points">
      <Row>
        {titles.map((title, index) => {
          return (
            <AppDetailContentDescriptionPoint
              key={`fulldesc-point-${index + 1}`}
              icon={icons[index]}
              title={title}
              point={points[index]}
              isDesktop={isDesktop}
            />
          );
        })}
      </Row>
    </div>
  );
};

AppDetailContentDescriptionPoints.propTypes = {
  partner: PropTypes.string,
  isDesktop: PropTypes.bool
};

export default AppDetailContentDescriptionPoints;
